module.exports = __webpack_public_path__ + "img/about-history-header.jpg?29c4d7da54086afe69c4ef83e86cebd8";